import React, { useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useFilteredItems } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/use-filtered-connect-items';
import {
	fireOperationalAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import { ConnectItem } from './connect-item';
import type { ConnectMenuProps } from './types';

export const ConnectMenu = ({
	items,
	overrides,
	showIcons = false,
	shouldFilter = true,
	submenuId = '',
}: ConnectMenuProps) => {
	const filteredItems = useFilteredItems(items || null, shouldFilter);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		if (fg('apps-temp-analytics-sidebar')) {
			const event = createAnalyticsEvent({});
			fireOperationalAnalytics(event, 'connectProjectSectionNavigation rendered', {
				appsCount: filteredItems?.length || 0,
			});
		}
	}, [filteredItems, createAnalyticsEvent]);

	if (filteredItems == null || !filteredItems.length) return null;

	return (
		<>
			{filteredItems.map((item, index) => (
				<ConnectItem
					item={item}
					key={item.id}
					index={index}
					overrides={overrides}
					showIcons={showIcons}
					submenuId={submenuId}
				/>
			))}
		</>
	);
};
